import { render, staticRenderFns } from "./LocPersonal.vue?vue&type=template&id=2fae3c8f&scoped=true"
import script from "./LocPersonal.vue?vue&type=script&lang=js"
export * from "./LocPersonal.vue?vue&type=script&lang=js"
import style0 from "./LocPersonal.vue?vue&type=style&index=0&id=2fae3c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae3c8f",
  null
  
)

export default component.exports